import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Input } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions } from 'react-native';
import trackerApi from '../../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as RootNavigation from '../../../../root.navigation.js';

const width = Dimensions.get('window').width;
const SendIcon = (props) => (
  <Icon {...props} name='paper-plane'
  style={[props.style, {width:24,height:24 }]}
  fill = '#f5f5f5'
  />
);
export const Writing = (props) => {
  const [message, setMessage] =useState('');
  const [disabled, setDisabled] =useState(true);

  const sendMessage = async()=>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/tickets/newreply', {queryId: props.query.id, message}, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status) RootNavigation.navigate('Menu');
    else console.log('error: ', response.data.message);
      // if(response.data.allData) setMessages(response.data.allData);
      // else null

  }
  return (
      <Layout style={styles.container} level='2' >

          { (!props.query.resolved || !props.query.resolved == '0') &&
          <>
          <Input
            value = {message}
            placeholder = 'پیام خود را بنویسید'
            onChangeText = { newValue =>{
              setMessage(newValue);
              if(newValue.length>0) setDisabled(false)
              else setDisabled(true)
              }
            }
            style={styles.input}
            status='primary'/>
          <Button disabled={disabled} style={styles.button} accessoryLeft={SendIcon} onPress={sendMessage}/>
          </>
          }
          { props.query.resolved =='1' &&
          <Button disabled={true} style={{width:width-30, borderRadius:10}}>درخواست بسته شده است.</Button>
          }
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    alignItems:'flex-end',
    flexDirection:'row',
    justifyContent:'flex-end',
    paddingTop:15,
    paddingBottom:25,
    paddingHorizontal:15,
    borderTopLeftRadius:20,
    borderTopRightRadius:20,
    marginTop:5
  },
  input:{
    flex:1,
    marginHorizontal:4,
    borderRadius:10
  },
  button:{
    borderRadius:10,
    marginHorizontal:4
  }
});
